// assets/datalayer.quickViewModalEventsConfig.js
export const quickViewModalEventsConfig = {
    parentSelector: '.quick-view-modal__content', // Target the modal container
    events: {
        // Quick View | Close modal (Adapt from Cart Modal Close)
        quickViewModalClose: {
            selector: 'button#ModalClose-QuickView',
            event: {
                event: 'quick_view_modal',
                component: 'quick_view_modal',
                element: 'modal',
                action: 'close',
                trigger: 'click',
                getDynamicData: (element) => {
                     // Get product name from within the modal if needed for context
                     const productTitleElement = element.closest('.quick-view-modal__content')?.querySelector('.product__title a.h2');
                     return {
                         product_name: productTitleElement ? productTitleElement.textContent.trim() : 'Unknown Product'
                     };
                }
            }
        },

        // Quick View | Vendor Link Click
        quickViewVendorClick: {
             selector: '.product__vendor-link',
             event: {
                 event: 'quick_view_modal',
                 component: 'quick_view_modal',
                 element: 'link',
                 action: 'click',
                 trigger: 'click',
                 getDynamicData: (element) => ({
                     link_text: element.textContent.replace('By','').trim(),
                     link_url: element.href
                 })
             }
         },

        // Quick View | Quantity Adjustments (Adapt from Cart Modal)
        quickViewQuantityFocus: {
            selector: '.quantity__input',
            event: {
                event: 'quick_view_modal',
                component: 'quick_view_modal',
                element: 'text_field',
                field: 'quantity',
                action: 'focus',
                trigger: 'focus',
                getDynamicData: (element) => {
                    const productTitleElement = element.closest('.quick-view-modal__content')?.querySelector('.product__title a.h2');
                    return { product_name: productTitleElement ? productTitleElement.textContent.trim() : 'Unknown Product' };
                }
            }
        },
        quickViewQuantityInput: {
            selector: '.quantity__input',
            event: {
                event: 'quick_view_modal',
                component: 'quick_view_modal',
                element: 'text_field',
                field: 'quantity',
                action: 'input',
                trigger: 'input',
                getDynamicData: (element) => {
                    const productTitleElement = element.closest('.quick-view-modal__content')?.querySelector('.product__title a.h2');
                    return {
                        product_name: productTitleElement ? productTitleElement.textContent.trim() : 'Unknown Product',
                        input_value: element.value
                    };
                }
            }
        },
        quickViewQuantityUp: {
            selector: '.quantity__button[name="plus"]',
            event: {
                event: 'quick_view_modal',
                component: 'quick_view_modal',
                element: 'chevron',
                field: 'quantity',
                action: 'click',
                action_value: 'up',
                trigger: 'click',
                 getDynamicData: (element) => {
                    const productTitleElement = element.closest('.quick-view-modal__content')?.querySelector('.product__title a.h2');
                    return { product_name: productTitleElement ? productTitleElement.textContent.trim() : 'Unknown Product' };
                }
            }
        },
        quickViewQuantityDown: {
            selector: '.quantity__button[name="minus"]',
            event: {
                event: 'quick_view_modal',
                component: 'quick_view_modal',
                element: 'chevron',
                field: 'quantity',
                action: 'click',
                action_value: 'down',
                trigger: 'click',
                 getDynamicData: (element) => {
                    const productTitleElement = element.closest('.quick-view-modal__content')?.querySelector('.product__title a.h2');
                    return { product_name: productTitleElement ? productTitleElement.textContent.trim() : 'Unknown Product' };
                }
            }
        },

        // Quick View | Add to Cart Click (Adapt from Product Card ATC)
        quickViewATC: {
            selector: 'button.product-form__submit',
            event: {
                event: 'quick_view_modal',
                component: 'quick_view_modal',
                element: 'cta_button',
                action: 'click',
                action_value: 'add_to_cart',
                trigger: 'click',
                getDynamicData: (element) => {
                    const modalContent = element.closest('.quick-view-modal__content');
                    if (!modalContent) return null;

                    const productTitleElement = modalContent.querySelector('.product__title a.h2');
                    const vendorElement = modalContent.querySelector('.product__vendor-link');
                    const priceElement = modalContent.querySelector('.price-item--regular'); // Assuming regular price is sufficient
                    const quantityInput = modalContent.querySelector('.quantity__input');
                     // Attempt to find product ID (might be in hidden input)
                    const productIdInput = modalContent.querySelector('input[name="product-id"], input[name="id"][value]'); // Look for common patterns
                    
                    const priceText = priceElement?.textContent.trim().replace(/[^0-9.,]+/g, '').replace(',', '.') || '0';
                    const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

                    return {
                        product_name: productTitleElement ? productTitleElement.textContent.trim() : 'Unknown Product',
                        product_id: productIdInput ? productIdInput.value : 'Unknown ID',
                        brand: vendorElement ? vendorElement.textContent.replace('By','').trim() : 'Unknown Brand',
                        price: parseFloat(priceText),
                        quantity: quantity,
                        click_text: element.querySelector('span')?.textContent.trim() || 'Aan winkelwagen toevoegen'
                    };
                }
            }
        },

        // Quick View | Gallery Arrow Click (Next)
        quickViewGalleryNext: {
            selector: '.product__slider-button[name="next"]',
            event: {
                event: 'quick_view_modal',
                component: 'quick_view_modal_gallery', // Component specific to the gallery
                element: 'chevron',
                action: 'click',
                action_value: 'next',
                trigger: 'click',
                getDynamicData: (element) => {
                     const productTitleElement = element.closest('.quick-view-modal__content')?.querySelector('.product__title a.h2');
                     return {
                         product_name: productTitleElement ? productTitleElement.textContent.trim() : 'Unknown Product'
                     };
                }
            }
        },

        // Quick View | Gallery Arrow Click (Previous)
        quickViewGalleryPrev: {
            selector: '.product__slider-button[name="previous"]',
            event: {
                event: 'quick_view_modal',
                component: 'quick_view_modal_gallery',
                element: 'chevron',
                action: 'click',
                action_value: 'previous',
                trigger: 'click',
                getDynamicData: (element) => {
                     const productTitleElement = element.closest('.quick-view-modal__content')?.querySelector('.product__title a.h2');
                     return {
                         product_name: productTitleElement ? productTitleElement.textContent.trim() : 'Unknown Product'
                     };
                }
            }
        },

        // Quick View | Description Link Click
        quickViewDescriptionLinkClick: {
             selector: '.product__description a',
             event: {
                 event: 'quick_view_modal',
                 component: 'quick_view_modal_description',
                 element: 'link',
                 action: 'click',
                 trigger: 'click',
                 getDynamicData: (element) => ({
                     link_text: element.textContent.trim(),
                     link_url: element.href
                 })
             }
         }
    }
}; 